import React from 'react'

export const PaperTwoLines = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" {...props}
  >
    <path d="M32 6C34.1088 6 35.8363 7.63175 35.989 9.70148L36 10V20H39C40.5593 20 41.8409 21.1898 41.9863 22.7111L42 23V38C42 41.1954 39.5022 43.8073 36.3526 43.9898L36 44H10C7.89128 44 6.16367 42.3683 6.01097 40.2985L6 40V10C6 7.89128 7.63175 6.16367 9.70148 6.01097L10 6H32ZM38 24H36V40C37.1046 40 38 39.1046 38 38V24ZM22 26H16C14.8954 26 14 26.8954 14 28C14 29.0257 14.7721 29.871 15.7668 29.9865L16 30H22C23.1046 30 24 29.1046 24 28C24 26.9743 23.2279 26.129 22.2332 26.0135L22 26ZM26 16H16C14.8954 16 14 16.8954 14 18C14 19.1046 14.8954 20 16 20H26C27.1046 20 28 19.1046 28 18C28 16.8954 27.1046 16 26 16Z" />
  </svg>
)
